import { NgClass } from '@angular/common';
import { AfterViewInit, Component,ElementRef,EventEmitter, Input,Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-bootstap-image-modal',
  standalone: true,
  imports: [NgClass],
  templateUrl: './bootstap-image-modal.component.html',
  styleUrl: './bootstap-image-modal.component.css'
})
export class BootstapImageModalComponent implements AfterViewInit{
  @Input() imgSrc: string = '';
  @Input() imgStampString: string = '';
  @Input() isVisible: boolean = false;
  @ViewChild('modalRef', { static: true }) modalRef!: ElementRef;

  @Output() close = new EventEmitter<void>();

  rotation: number = 0;
  divHeight: string = 'auto';

  rotate(angle: number, imgModal?: HTMLImageElement) {
  this.rotation = (this.rotation + angle) % 360;

  setTimeout(() => {
    if (imgModal) {
      const rect = imgModal.getBoundingClientRect();
      this.divHeight = rect.width + 20 + 'px';
      console.log('Updated divHeight:', this.divHeight);
    }
  });
}

ngAfterViewInit() {
  this.modalRef.nativeElement.addEventListener('click', (event: any) => {
    if (event.target === this.modalRef.nativeElement) {
      this.onClose();
    }
  });
}

  onClose() {
    this.rotation = 0;
    this.divHeight = 'auto';
    this.close.emit();
  }
}
